let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("je1QC")).then(() => parcelRequire('gsB19'));